// extracted by mini-css-extract-plugin
export default {"withPopover":"NavigationWrapper_withPopover__rIDTH"};